import React from 'react';
import { AboutUs1, AboutUs2, AboutUs3 } from '../components/Icons/Icons'


const AboutUs = () => {
  return (
    <div className="min-h-screen section-padding">
      <div className="container">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="display-md text-white mb-6">About Us</h1>
          </div>
        </div>
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <p className="body-lg mb-8">Most sales teams know the frustration. The CRM they were promised would save time ends up taking it: records to update, notes to log, and reports to build by hand. Growing businesses feel this most, because the tools that do the job well tend to be built for large enterprises, with the complexity and cost to match.</p>
            <p className="body-lg mb-8">CXSquare started in 2026 to change that. We are a team of engineers, data scientists, and people with hands-on sales experience, and we began with a simple belief: growing businesses deserve enterprise-grade tools without enterprise-level complexity or cost. That belief has shaped every decision since.</p>
            <p className="body-lg mb-8">So we built the platform around AI from the start, rather than adding it later. It learns your company, your products, and your customers, and it gets more useful the longer your team works with it. Instead of only storing customer records, it helps your team understand each interaction, anticipate what a customer needs next, and act at the right moment.</p>
            <p className="body-lg mb-8">Underneath the technology is a conviction we hold firmly: great sales start with great relationships. As Zig Ziglar once said, “You don’t build a business. You build people, and then people build the business.” That idea guides how we design CXSquare. It is meant to help teams build stronger connections with customers, understand their needs before they are spelled out, and turn those relationships into steady growth.</p>
          </div>

          <div className="relative">
            <div className="aspect-square bg-gradient-to-br from-green-400/20 to-transparent rounded-2xl p-8">
              <div className="h-full bg-slate-800 rounded-xl flex items-center justify-center">
                <div className="text-center">
                  <AboutUs1 className="h-32 w-32 text-green-400 mx-auto mb-6" />
                  <h3 className="h2 text-white mb-2">Who We Are</h3>
                  <p className="body-md text-slate-400">Passionate innovators creating future-ready CRM for all businesses</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="grid lg:grid-cols-2 gap-16 items-center mb-8">
          <div className="relative">
            <div className="aspect-square bg-gradient-to-br from-green-400/20 to-transparent rounded-2xl p-8">
              <div className="h-full bg-slate-800 rounded-xl flex items-center justify-center">
                <div className="text-center">
                  <AboutUs2 className="h-32 w-32 text-green-400 mx-auto mb-6" />
                  <h3 className="h2 text-white mb-2">What Makes Us Different</h3>
                  <p className="body-md text-slate-400">Combining simplicity and power, we make CRM truly accessible</p>
                </div>
              </div>
            </div>
          </div>
          <div>
            <p className="body-lg mb-8">Three principles shape everything we build:</p>
            <p className="body-lg mb-8"><strong>Practical:</strong> Built from the real-world experience of sales and customer-facing teams, so it fits the way people actually work.</p>
            <p className="body-lg mb-8"><strong>Intuitive:</strong> Designed to be simple from the start, so every user, from a small startup to a large enterprise, can get value quickly.</p>
            <p className="body-lg mb-8"><strong>Commercially viable:</strong> Powerful but accessible, with the capabilities of an enterprise CRM at a price that growing businesses can afford.</p>
          </div>

        </div>
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <p className="body-lg mb-8">We believe customer experience and sales cannot be separated. When AI helps your team understand each customer’s business and the problems they are trying to solve, your team can offer solutions that fit. Satisfied customers become loyal customers, and loyal customers drive revenue.</p>
            <p className="body-lg mb-8">Our goal is to help businesses of all sizes grow with more confidence and less guesswork. Whether you are a startup building your first pipeline or a global enterprise managing complex operations, CXSquare is here to help you build growth that is predictable and scalable.</p>
          </div>

          <div className="relative">
            <div className="aspect-square bg-gradient-to-br from-green-400/20 to-transparent rounded-2xl p-8">
              <div className="h-full bg-slate-800 rounded-xl flex items-center justify-center">
                <div className="text-center">
                  <AboutUs3 className="h-32 w-32 text-green-400 mx-auto mb-6" />
                  <h3 className="h2 text-white mb-2">Our Vision</h3>
                  <p className="body-md text-slate-400">Customer satisfaction fuels loyalty; loyalty drives scalable business growth</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
